export const getConformantId = (queryKey) => typeof queryKey === "string" ? [queryKey] : queryKey;
export const getDefaultQueryIdentifier = (query, namespace) => {
    // oxlint-disable-next-line no-unused-vars
    const { messageId, occurredOn, ...queryPayload } = query;
    const identifier = [query.name, JSON.stringify(queryPayload)];
    return namespace ? [...identifier, namespace] : identifier;
};
